import { createAsyncThunk } from '@reduxjs/toolkit'
import RestClient from '../../../services/client/RestClient'
import Configuration from '../../../services/api/Configuration'
import CookiesStorageService from '../../../services/CookiesStorageService'

const getRolesApi = Configuration.Roles_Endpoints

export const retrieveSystemAdminRoles = createAsyncThunk('roles/getRoles', async ({ queries }) => {
  const response = await RestClient.getRequest(`${getRolesApi.systemAdminRoles}${queries.company_id ? `?company_id=${queries.company_id}` : ''}`, {
    headers: {
      tenant_id: queries.tenant,
    },
  })
  return response.data || []
})

export const retrieveCustomerAdminRoles = createAsyncThunk('roles/getRoles', async () => {
  const response = await RestClient.getRequest(`${getRolesApi.customerAdminRoles}`)
  return response.data || []
})

export const searchRoles = createAsyncThunk('roles/searchRoles', async ({ queries, actionProps }, { getState }) => {
  const { sysAdminUsers, customerAdminUsers } = getState()
  const companyId = CookiesStorageService.getAdminType() === 'sys_admin'
    ? sysAdminUsers?.updatedUser?.company?.id : customerAdminUsers?.updatedUser?.company?.id;

  const url = CookiesStorageService.getAdminType() === 'sys_admin'
    ? getRolesApi.systemAdminRoles : getRolesApi.customerAdminRoles;

  const response = await RestClient.getRequest(`${url}?search=${queries || ''}&company_id=${companyId}`, {
    headers: {
      ...actionProps,
    },
  })

  return {
    data: response,
    search: queries,
  }
})
